// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-products-card-product-bonus-bonus-fankd{align-items:center;background:color-mix(in sRGB,currentColor 12%,transparent);border-radius:6px;display:inline-flex;line-height:1.2;padding:3px 8px;color:var(--color-primary);font-size:13px;grid-gap:6px;gap:6px}.components-products-card-product-bonus-icon-kakks{height:16px;width:16px;flex-shrink:0}.components-products-card-product-bonus-bold-lrsuu{font-weight:700}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bonus": "components-products-card-product-bonus-bonus-fankd",
	"icon": "components-products-card-product-bonus-icon-kakks",
	"bold": "components-products-card-product-bonus-bold-lrsuu"
};
module.exports = ___CSS_LOADER_EXPORT___;
